import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0e433b93 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _e0a171da = () => interopDefault(import('../pages/adviser/index.vue' /* webpackChunkName: "pages/adviser/index" */))
const _e64111b4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _73e24fc1 = () => interopDefault(import('../pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _7890b052 = () => interopDefault(import('../pages/emailchange.vue' /* webpackChunkName: "pages/emailchange" */))
const _71c1348e = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _74e8e1f3 = () => interopDefault(import('../pages/example/index.vue' /* webpackChunkName: "pages/example/index" */))
const _1f51f813 = () => interopDefault(import('../pages/letter/index.vue' /* webpackChunkName: "pages/letter/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _2f678295 = () => interopDefault(import('../pages/logoff.vue' /* webpackChunkName: "pages/logoff" */))
const _813a62d2 = () => interopDefault(import('../pages/logoffdone.vue' /* webpackChunkName: "pages/logoffdone" */))
const _3565e2b2 = () => interopDefault(import('../pages/passwordforget.vue' /* webpackChunkName: "pages/passwordforget" */))
const _a60e8bcc = () => interopDefault(import('../pages/passwordreset.vue' /* webpackChunkName: "pages/passwordreset" */))
const _37e8fae4 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5fba350d = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _49a7850f = () => interopDefault(import('../pages/registerdone.vue' /* webpackChunkName: "pages/registerdone" */))
const _86457c34 = () => interopDefault(import('../pages/rule.vue' /* webpackChunkName: "pages/rule" */))
const _2d264eba = () => interopDefault(import('../pages/seminar/index.vue' /* webpackChunkName: "pages/seminar/index" */))
const _aa612f3e = () => interopDefault(import('../pages/serial/index.vue' /* webpackChunkName: "pages/serial/index" */))
const _62e00883 = () => interopDefault(import('../pages/tags.vue' /* webpackChunkName: "pages/tags" */))
const _7f799735 = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _6cf27be3 = () => interopDefault(import('../pages/topic/tags.vue' /* webpackChunkName: "pages/topic/tags" */))
const _1679f23b = () => interopDefault(import('../pages/adviser/_id.vue' /* webpackChunkName: "pages/adviser/_id" */))
const _6bd234a7 = () => interopDefault(import('../pages/article/_id.vue' /* webpackChunkName: "pages/article/_id" */))
const _191cc51b = () => interopDefault(import('../pages/example/_id.vue' /* webpackChunkName: "pages/example/_id" */))
const _3dd6398a = () => interopDefault(import('../pages/letter/_id.vue' /* webpackChunkName: "pages/letter/_id" */))
const _2d8cb7a2 = () => interopDefault(import('../pages/seminar/_id.vue' /* webpackChunkName: "pages/seminar/_id" */))
const _4e2e0f09 = () => interopDefault(import('../pages/serial/_id.vue' /* webpackChunkName: "pages/serial/_id" */))
const _09730d90 = () => interopDefault(import('../pages/topic/_name.vue' /* webpackChunkName: "pages/topic/_name" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _0e433b93,
    name: "about"
  }, {
    path: "/adviser",
    component: _e0a171da,
    name: "adviser"
  }, {
    path: "/contact",
    component: _e64111b4,
    name: "contact"
  }, {
    path: "/cookie-policy",
    component: _73e24fc1,
    name: "cookie-policy"
  }, {
    path: "/emailchange",
    component: _7890b052,
    name: "emailchange"
  }, {
    path: "/error",
    component: _71c1348e,
    name: "error"
  }, {
    path: "/example",
    component: _74e8e1f3,
    name: "example"
  }, {
    path: "/letter",
    component: _1f51f813,
    name: "letter"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/logoff",
    component: _2f678295,
    name: "logoff"
  }, {
    path: "/logoffdone",
    component: _813a62d2,
    name: "logoffdone"
  }, {
    path: "/passwordforget",
    component: _3565e2b2,
    name: "passwordforget"
  }, {
    path: "/passwordreset",
    component: _a60e8bcc,
    name: "passwordreset"
  }, {
    path: "/privacy",
    component: _37e8fae4,
    name: "privacy"
  }, {
    path: "/register",
    component: _5fba350d,
    name: "register"
  }, {
    path: "/registerdone",
    component: _49a7850f,
    name: "registerdone"
  }, {
    path: "/rule",
    component: _86457c34,
    name: "rule"
  }, {
    path: "/seminar",
    component: _2d264eba,
    name: "seminar"
  }, {
    path: "/serial",
    component: _aa612f3e,
    name: "serial"
  }, {
    path: "/tags",
    component: _62e00883,
    name: "tags"
  }, {
    path: "/user",
    component: _7f799735,
    name: "user"
  }, {
    path: "/topic/tags",
    component: _6cf27be3,
    name: "topic-tags"
  }, {
    path: "/adviser/:id",
    component: _1679f23b,
    name: "adviser-id"
  }, {
    path: "/article/:id?",
    component: _6bd234a7,
    name: "article-id"
  }, {
    path: "/example/:id",
    component: _191cc51b,
    name: "example-id"
  }, {
    path: "/letter/:id",
    component: _3dd6398a,
    name: "letter-id"
  }, {
    path: "/seminar/:id",
    component: _2d8cb7a2,
    name: "seminar-id"
  }, {
    path: "/serial/:id",
    component: _4e2e0f09,
    name: "serial-id"
  }, {
    path: "/topic/:name?",
    component: _09730d90,
    name: "topic-name"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
